import { Link } from "react-router-dom";
import { Check, Moon, Users } from "lucide-react";

export default function PackageCard({ pkg, destinationName }) {
  return (
    <article
      data-testid={`package-card-${pkg.id}`}
      className="card-flat p-8 flex flex-col h-full"
    >
      <div className="flex items-center justify-between mb-5">
        <div className="overline">{pkg.nights} Nights</div>
        <div className="flex items-center gap-1.5 text-[#0B192C]">
          <Moon className="h-4 w-4 text-[#FF5238]" />
          <span className="font-heading text-sm font-semibold">{pkg.nights}N</span>
        </div>
      </div>

      <h3 className="font-heading text-2xl font-medium tracking-tight text-[#0B192C] mb-3">
        {pkg.title}
      </h3>
      <p className="text-sm text-slate-600 leading-relaxed mb-6">{pkg.summary}</p>

      <div className="mb-6">
        <div className="text-xs text-slate-500 mb-1">Starting from</div>
        <div className="flex items-baseline gap-2">
          <span className="font-heading text-4xl font-light text-[#0B192C]">
            ${pkg.price_from}
          </span>
          <span className="text-sm text-slate-500">/ pax</span>
        </div>
      </div>

      <ul className="space-y-2.5 mb-6">
        {pkg.inclusions.slice(0, 5).map((item) => (
          <li key={item} className="flex items-start gap-2 text-sm text-slate-700">
            <Check className="h-4 w-4 text-[#FF5238] mt-0.5 shrink-0" />
            <span>{item}</span>
          </li>
        ))}
      </ul>

      <div className="mt-auto pt-6 border-t border-slate-100 flex items-center gap-3">
        <div className="flex-1 flex items-center gap-2 text-xs text-slate-500">
          <Users className="h-3.5 w-3.5" />
          {pkg.ideal_for}
        </div>
      </div>

      <div className="mt-5 flex items-center gap-3">
        <Link
          to={`/inquiry?destination=${pkg.destination_slug}&nights=${pkg.nights}&pkg=${pkg.id}`}
          data-testid={`package-inquire-${pkg.id}`}
          className="btn-primary text-sm !py-3 !px-5 flex-1 justify-center"
        >
          Request Proposal
        </Link>
        <Link
          to={`/quote?dest=${pkg.destination_slug}&nights=${pkg.nights}`}
          data-testid={`package-ai-quote-${pkg.id}`}
          className="btn-ghost text-sm !px-4 border border-slate-200 hover:bg-[#FDFCF8]"
        >
          AI Quote
        </Link>
      </div>
    </article>
  );
}
